// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"assessment-leadership-filter_wrapper__2icmM","selected":"assessment-leadership-filter_selected__1oeR1"};